import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import './assets/style.scss';

const getInitials = () => {
    try {
        const userString = localStorage.getItem('user');
        if(!userString) {
            return {initials: '?', fullname: null, erpUsername: null};
        }

        const user = JSON.parse(userString);
        const general = user.general;
        const erp = user.erp;

        let initials = '?';
        let fullname = null;
        let erpUsername = null;

        // Если есть general (не null и не undefined), используем его данные
        if (general && typeof general === 'object') {
            const surname = general.surname || '';
            const firstName = general.first_name || '';
            const middleName = general.middle_name || '';

            // Вычисляем initials из surname
            if (typeof surname === 'string' && surname.length > 0) {
                initials = surname.charAt(0).toUpperCase();
            }

            // Формируем fullname из first_name, middle_name и surname через пробел
            const nameParts = [firstName, middleName, surname].filter(Boolean);
            fullname = nameParts.length > 0 ? nameParts.join(' ').trim() : null;
        } else if (erp && erp.username) {
            // Если нет general, но есть erp, используем erp.username для initials
            const username = erp.username || '';
            if (typeof username === 'string' && username.length > 0) {
                initials = username.charAt(0).toUpperCase();
            }
        }

        // Сохраняем erp.username если он есть
        if (erp && erp.username) {
            erpUsername = erp.username;
        }

        return { initials, fullname, erpUsername };
    } catch(e) {
        console.error('Ошибка чтения данных из localStorage', e);
        return {initials: '?', fullname: null, erpUsername: null }
    }
    
}

export const UserInfo = ({ onLogout }) => {
    const [isOpen, setIsOpen] = useState(false);
    const authMenuRef = useRef(null);
    const [userInfo, setUserInfo] = useState(() => getInitials());

    // Обновление userInfo при изменении localStorage
    useEffect(() => {
        const updateUserInfo = () => {
            setUserInfo(getInitials());
        };

        // Обработчик события storage (для изменений из других вкладок)
        const handleStorageChange = (e) => {
            if (e.key === 'user') {
                updateUserInfo();
            }
        };

        // Обработчик кастомного события для изменений в текущем окне
        const handleUserUpdate = () => {
            updateUserInfo();
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('userStorageUpdate', handleUserUpdate);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('userStorageUpdate', handleUserUpdate);
        };
    }, []);

    // Закрытие при клике вне компонента
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (authMenuRef.current && !authMenuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const toggleModal = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="Constructor-UserInfo" ref={authMenuRef}>
            <div className="Constructor-UserInfo-Initials" onClick={toggleModal}>
                {userInfo.initials}
            </div>
            {isOpen && (
                <div className="Constructor-UserInfo-Modal">
                    <ul className="Constructor-UserInfo-Modal-List">
                        {userInfo.fullname && (
                            <li className="Constructor-UserInfo-Modal-Item">
                                {userInfo.fullname}
                            </li>
                        )}
                        {userInfo.erpUsername && (
                            <li className="Constructor-UserInfo-Modal-Item Constructor-UserInfo-Modal-Item_bold">ERP: {userInfo.erpUsername}</li>
                        )}
                        <li 
                            className="Constructor-UserInfo-Modal-Item Constructor-UserInfo-Modal-Item_exit"
                            onClick={(e) => {
                                e.preventDefault();
                                if (onLogout) {
                                    onLogout(e);
                                }
                                setIsOpen(false);
                            }}
                        >
                            Выйти
                        </li>
                    </ul>
                </div>
            )}
        </div>
    );
};

UserInfo.propTypes = {
    onLogout: PropTypes.func.isRequired,
};

UserInfo.displayName = 'UserInfo';